<script lang="ts">
  import type { Section } from "src/ts/Classes";
  import TextLineGroup from "./TextLineGroup.svelte";

  export let sections: Section[];
</script>

{#each sections as section}
  {#if !section.hideSection && section.lines.length > 0}
    <TextLineGroup sectionName={section.name} bind:lines={section.lines} />
  {/if}
{/each}
